const customPDPPrice = document.querySelector('[data-custom-pricing]');
if(customPDPPrice) {
  setInterval(() => {
    const rate = (100 - parseFloat(customPDPPrice.getAttribute('data-discount-percent') || '0')) / 100.0;
    try {
      const selectedVariantId = parseInt(document.querySelector('[name="id"]').value);
      const selectedVariant = window.productData.variants.filter(v => v.id == selectedVariantId)[0];
      const originalPrice = selectedVariant.price / 100.0;
      const discountedPrice = originalPrice * rate;
      const totalAddonPrice = Array.from(document.querySelectorAll('.bcpo-checkboxes input[type="checkbox"]:checked')).reduce((partialSum, input) => partialSum + parseFloat(input.getAttribute('data-price')), 0);
      customPDPPrice.innerHTML = `
        <price-list class="price-list price-list--product">
          <sale-price class="${originalPrice <= discountedPrice ? '' : 'text-on-sale'} h4">
            <span class="sr-only">Sale price</span>
            <span class="price--sale">
              <span class="transcy-money">$${(discountedPrice + totalAddonPrice).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${Shopify.currency.active}</span>
            </span>
            <span class="price--original text-subdued line-through" style="margin-left: 0.5rem;${originalPrice <= discountedPrice ? 'display:none!important;' : ''}">
              <span class="transcy-money">$${(originalPrice + totalAddonPrice).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${Shopify.currency.active}</span>
            </span>
          </sale-price>
        </price-list>
      `;
    } catch (error) {
      console.log('Error: update PDP price', error)
    }
  }, 200);
}